import {twMerge} from '../../../common/twMerge';
import {StaticImage} from '../StaticImage/StaticImage';
import {IconProps} from './IconProps.interface';

export function Icon({
  type,
  disabled,
  disableActiveEffect = false,
  ariaHidden = true,
  className,
  ...props
}: IconProps) {
  return (
    <StaticImage
      className={twMerge(
        disabled && 'pointer-events-none opacity-30',
        !disableActiveEffect ? 'active:opacity-30' : 'pointer-events-none',
        !!props.onClick && !disabled && 'cursor-pointer',
        className
      )}
      imageType={type}
      aria-hidden={ariaHidden}
      {...props}
    />
  );
}
